import { InputAdornment, TextField, TextFieldProps, useTheme } from '@mui/material'
import React from 'react'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'

const TextSearchField: React.FC<TextFieldProps> = (props) => {
    const theme = useTheme()
    return (
        <TextField
            {...props}
            type='search'
            size='small'
            name='search'
            autoComplete='off'
            style={{
                paddingTop: theme.spacing(2),
                backgroundColor: theme.palette.customBackground.default,
                minWidth: 120,
                ...props.style,
            }}
            placeholder='Hledat...'
            InputProps={{
                startAdornment: (
                    <InputAdornment position='start'>
                        <SearchRoundedIcon />
                    </InputAdornment>
                ),
                style: {
                    maxHeight: 36,
                }
            }}
        />
    )
}

export default TextSearchField
